import * as React from 'react';
import { Dispatch } from 'redux';
import './Register.less';
import { Form, Row, Col, Button, Input, message, Select } from 'antd';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import bindAllOfThis from 'src/utils/BindThisHelper';
import Routes from 'src/core/Routes';
import { FormComponentProps } from 'antd/lib/form';
import { LocalizeContextProps, withLocalize, Translate } from 'react-localize-redux';
import { PageProps } from 'src/models/common/ComponentProps';
import { ReduxStoreModel } from 'src/redux/ReduxModel';
import UserAction, { updateUserError } from 'src/redux/UserActions';
import RegisterDTO from 'src/models/account/RegisterDTO';
import { UserState } from 'src/redux/UserReducer';
import FullscreenApi from 'src/utils/FullscreenHelper';
import RoleRedirect from 'src/utils/RoleRedirect';
import { ConstantState } from 'src/redux/ConstantReducer';
import DebugUtil from 'src/utils/DebugUtil';
import { ConfigState } from 'src/redux/ConfigReducer';
import ConfigAction from 'src/redux/ConfigActions';
import Languages from 'src/constants/Languages';
import { Grades } from 'src/constants/Grades';
import KeyValueDTO from 'src/models/generic/KeyValueDTO';
import SchoolApiController from 'src/api/SchoolApiController';
import ArrayUtil from 'src/utils/ArrayUtil';

const logo = require('src/assets/branding/logo.png');

interface RegisterProps extends PageProps<{}>, LocalizeContextProps, FormComponentProps {
  // From Redux
  User: UserState;
  Constants: ConstantState;
  Config: ConfigState;
  register: (registerModel: RegisterDTO) => Promise<boolean>;
  updateUserError: (msg: string) => void;
  clearPreviousLocation: () => void;
}

interface RegisterFormState {
  schools: KeyValueDTO<number, string>[];
  schoolId: number;

    // Filtering
    filteredDistricts: KeyValueDTO<number, string>[];
    filteredSchools: KeyValueDTO<number, string>[];
    isFilteringDistrict: boolean;
    isFilteringSchool: boolean;

    useSchoolClients: boolean;

    // Loading indicators
    isLoadingDistricts: boolean;
    isLoadingSchools: boolean;
    isSubmitting: boolean;
}

class RegisterAfl extends React.Component<RegisterProps, RegisterFormState> {
  constructor(props: RegisterProps) {
    super(props);
    bindAllOfThis(this, RegisterAfl.prototype);

    this.state = {
      schools: [],
      schoolId: 0,

      filteredDistricts: [],
      filteredSchools: [],
      isFilteringDistrict: false,
      isFilteringSchool: false,

      useSchoolClients: false,
      isLoadingDistricts: true,
      isLoadingSchools: true,
      isSubmitting: false,
    };
  }

  componentWillMount() {
    this.checkUserRegister(this.props);
    this.getSchools();

  }

  private getSchools() {
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let clientId = parseInt(params.get('clientId'));

    if (isNaN(clientId)) {
      return;
    }

    this.setState({ isLoadingSchools: true });
    return SchoolApiController.getAllSchoolsByClientId(clientId).then((result) => {
      this.setState({
        schools: result.data.sort((a, b) => a.value < b.value ? -1 : a.value > b.value ? 1 : 0),
        isLoadingSchools: false
      });
    }).catch(e => {
      message.error(<Translate id="admin.addEditDistrict.messageRetrieveError" />);
      this.setState({ isLoadingSchools: false });
    });
  }

  private handleSchoolSearch(value: string) {
      let input = (value || "").toLowerCase();

      // Filter the districts if input is 2+ chars OR if the number of districts is small, like 50 or so
      if (input.length >= 2 || this.state.schools.length < 50) {
          let filteredSchools = this.state.schools
              .filter(x => x.value.toLowerCase().indexOf(input) >= 0);
          this.setState({
              filteredSchools: ArrayUtil.Unique(filteredSchools),
              isFilteringSchool: true
          });
          return;
      }

      this.setState({
          filteredSchools: [],
          isFilteringSchool: false
      });
  }

  private handleSchoolBlur() {
      // Run through the same logic, but make sure we cleared out the text
      this.handleSchoolSearch("");
  }

  private handleSchoolFilter(event) {
    this.setState({ schoolId: event }, () => {
      console.log(this.state.schoolId, 'schoolId');
    });
  }

  componentWillReceiveProps(nextProps: RegisterProps) {
    if (this.props.User.errorMsg !== nextProps.User.errorMsg && nextProps.User.errorMsg !== '') {
      message.error(this.props.translate(nextProps.User.errorMsg));
      this.props.updateUserError('');
    }

    this.checkUserRegister(nextProps);
  }

  private handleRegister(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();

    // Prevent crushing the register button
    if (this.props.User.state === 'loading') {
      return;
    }

    this.props.form.validateFields((errors, values: RegisterDTO) => {
      // Make sure all fields are filled out
      if (!errors) {
        // Fire the register request
        if (!DebugUtil.isDebugEnabled()) {
          FullscreenApi.RequestFullscreen(document.body);
        }

        this.props.register(values);
      }
    });
  }

  private checkUserRegister(props: RegisterProps) {
    if (props.User.state === 'finished' && props.Constants.state === 'finished') {
      // User is logged in and can be directed to either their homepage, or a redirect page if one is set
      // JB: This will set the language whenever the register page is rendered
      if (this.props.User.cultureCode != null) {
        let language = Languages.FindByCode(this.props.User.cultureCode);
        this.props.setActiveLanguage(language.code);
      }

      let route = RoleRedirect.GetRoleRoute(props.User.roleID, props.User.gradeId);
      if (this.props.Config.previousLocation != null) {
        route = this.props.Config.previousLocation;
        this.props.clearPreviousLocation();
      }

      // With this, we can skip the rendering cost of the register page and just send the user to the proper page
      // Set push to false to remove '/register' from the users history
      return props.history.replace(route);
    }
  }


  private compareToFirstPassword = (rule, value, callback) => {
    if (value && value !== this.props.form.getFieldValue('password')) {
        callback(this.props.translate('account.resetPassword.saveTooltip').toString());
    } else {
        callback();
    }
  }

  private validateToNextPassword = (rule, value, callback) => {
      if (this.props.form.getFieldValue('confirmPassword')) {
          this.props.form.validateFields(['confirmPassword'], { force: true });
      }
      callback();
  }

  render() {
    let schoolsDisabled = this.state.useSchoolClients || this.state.isLoadingSchools;
    return (
      <div>
        <Row type="flex" justify="center">
          <Col xs={22} sm={22} md={18} lg={14} xl={11} className="register-form">
            <Link to={Routes.BASE_ROUTE} className="logo" tabIndex={-1}>
              <img src={logo} alt="Kuder Galaxy" height="100%" width="100%" tabIndex={-1} />
            </Link>

            <Form hideRequiredMark onSubmit={this.handleRegister}>
              <h3><Translate id="account.register.header1" /></h3>

              <Form.Item>
                <label className="screen-reader-hidden" htmlFor="firstName">
                  <Translate id="account.register.firstName" />
                </label>
                {this.props.form.getFieldDecorator('firstName', {
                  rules: [{ required: true, message: this.props.translate('admin.common.requiredRule').toString() }]
                })(
                  <Input
                    size="large"
                    aria-label={this.props.translate('account.register.firstName').toString()}
                    placeholder={this.props.translate('account.register.firstName').toString()}
                  />
                )}
              </Form.Item>

              <Form.Item>
                <label className="screen-reader-hidden" htmlFor="lastName">
                  <Translate id="account.register.lastName" />
                </label>
                {this.props.form.getFieldDecorator('lastName', {
                  rules: [{ required: true, message: this.props.translate('admin.common.requiredRule').toString() }]
                })(
                  <Input
                    size="large"
                    aria-label={this.props.translate('account.register.lastName').toString()}
                    placeholder={this.props.translate('account.register.lastName').toString()}
                  />
                )}
              </Form.Item>

              <Form.Item>
                <label className="screen-reader-hidden" htmlFor="email">
                  <Translate id="account.register.email" />
                </label>
                {this.props.form.getFieldDecorator('email', {
                  rules: [
                    { required: true, message: this.props.translate('admin.common.requiredRule').toString() },
                    { pattern: /^.+\@.+\..+$/, message: this.props.translate('admin.common.emailRule').toString() }
                  ]
                })(
                  <Input
                    size="large"
                    aria-label={this.props.translate('account.register.email').toString()}
                    placeholder={this.props.translate('account.register.email').toString()}
                  />
                )}
              </Form.Item>

              <Form.Item>
                <label className="screen-reader-hidden" htmlFor="cultureId">
                  <Translate id="account.register.culture" />
                </label>
                {this.props.form.getFieldDecorator('cultureId', {
                  rules: [{ required: true, message: this.props.translate('admin.common.requiredRule').toString() }]
                })(
                  <Select
                    placeholder={<Translate id="account.register.languageSelect" />}
                    showSearch
                    size="large"
                    {...{ showAction: ["focus", "click"] }}
                  >
                    {this.generateLanguageOptions()}
                  </Select>
                )}
              </Form.Item>

              <Form.Item>
                <label className="screen-reader-hidden" htmlFor="gradeId">
                  <Translate id="account.register.gradeLevel" />
                </label>
                {this.props.form.getFieldDecorator('gradeId', {
                  rules: [{ required: true, message: this.props.translate('admin.common.requiredRule').toString() }]
                })(
                  <Select
                    optionFilterProp="title"
                    placeholder={<Translate id="account.register.selectGrade" />}
                    showSearch
                    size="large"
                    {...{ showAction: ["focus", "click"] }}
                  >
                    {Grades.All.map(x => (
                      <Select.Option key={`grade${x.id}`} value={x.id}>
                        {x.shortName}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </Form.Item>

              <Form.Item>
                <label className="screen-reader-hidden" htmlFor="schoolId">
                  <Translate id="account.register.librarySearch.name" />
                </label>
                {this.props.form.getFieldDecorator('schoolid', {
                  rules: [{ required: true, message: this.props.translate('admin.common.requiredRule').toString() }]
                })(<Select
                  optionFilterProp="title"
                  placeholder={<Translate id="account.register.librarySearch.select" />}
                  size="large"

                  allowClear
                  showSearch
                  disabled={schoolsDisabled}
                  showArrow={false}
                  notFoundContent={null}
                  onChange={this.handleSchoolFilter}
                  onSearch={this.handleSchoolSearch}
                  onBlur={this.handleSchoolBlur}
                  {...{ showAction: ["focus", "click"] }}
                >
                  {
                    this.state.filteredSchools.map(x => <Select.Option key={x.key} value={x.key} title={x.value}>{x.value}</Select.Option>)
                  }
                </Select>)}
              </Form.Item>

              <Form.Item>
                <label className="screen-reader-hidden" htmlFor="password">
                  <Translate id="account.register.password" />
                </label>
                {this.props.form.getFieldDecorator('password', {
                  rules: [
                    { required: true, message: <Translate id="admin.common.requiredRule" /> },
                    { min: 8, message: <React.Fragment><Translate id="admin.common.minLengthRule" /> 8</React.Fragment> },
                    { validator: this.validateToNextPassword }
                ]
                })(
                  <Input
                    size="large"
                    aria-label={this.props.translate('account.register.password').toString()}
                    placeholder={this.props.translate('account.register.password').toString()}
                    autoComplete="off"
                    type="password"
                  />
                )}
              </Form.Item>

              <Form.Item>
                <label className="screen-reader-hidden" htmlFor="confirmPassword">
                  <Translate id="account.register.confirmPassword" />
                </label>
                {this.props.form.getFieldDecorator('confirmPassword', {
                  rules: [
                    { required: true, message: <Translate id="admin.common.requiredRule" /> },
                    { validator: this.compareToFirstPassword }
                ]
                })(
                  <Input
                    size="large"
                    aria-label={this.props.translate('account.register.confirmPassword').toString()}
                    placeholder={this.props.translate('account.register.confirmPassword').toString()}
                    autoComplete="off"
                    type="password"
                  />
                )}
              </Form.Item>

              <Form.Item>
                <Button loading={this.props.User.state === 'loading'} size="large" type="primary" htmlType="submit">
                  {this.props.User.state !== 'loading' && this.props.translate('account.register.registerButton')}
                </Button>
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </div>
    );
  }

  private generateLanguageOptions() {
    // Only available languages
    return Languages.All.filter(x => x.isAvailable && x.code !=='en-au').map(x => (
      <Select.Option key={`cultureIds${x.id}`} value={x.id}>
        {x.name} ({x.code})
      </Select.Option>
    ));
  }
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
  return {
    register: (registerModel: RegisterDTO) => UserAction.Register(dispatch, registerModel),
    updateUserError: (msg: string) => updateUserError(dispatch, msg),
    clearPreviousLocation: () => ConfigAction.SetPreviousLocation(dispatch, null)
  };
}

function mapStateToProps(state: ReduxStoreModel) {
  return {
    User: state.User,
    Constants: state.Constants,
    Config: state.Config
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(Form.create()(RegisterAfl)));



// WEBPACK FOOTER //
// ./src/pages/account/Register-AFL.tsx